'use client';

import { type PropsWithChildren } from 'react';

import { type ResolvedContextData } from '@common/defaults/ContextData';

import { NextContext } from './NextContext';

export interface ContextDataProviderProps extends PropsWithChildren {
    contextData: Readonly<ResolvedContextData>;
}

export const ContextDataProvider = ({ contextData, children }: ContextDataProviderProps) => {
    return <NextContext.Provider value={contextData}>{children}</NextContext.Provider>;
};
